const getters = {
  getDevState: state => {
    return state
  },
  currentStep: state => {
    return state.currentStep
  },
  steps: state => {
    return state.steps
  },
  mode: state => {
    return state.mode
  },
  selectedGroupId: state => {
    return state.selectedGroup.id
  },
  selectedGroupType: state => {
    return state.selectedGroup.type
  },
  selectedLocation: state => {
    return state.selectedLocation
  },
  mapCenter: state => {
    return state.mapCenter
  },
  mapZoom: state => {
    return state.mapZoom
  },
  lastDragEndTime: state => {
    return state.lastDragEndTime
  },
  fitBounds: state => {
    return state.fitBounds
  },
  lastSettingAreaHeight: state => {
    return state.lastSettingAreaHeight
  },
  isSearching: ({ search }) => {
    return search.isSearching
  },
  locationSearchResults: ({ search }) => {
    return search.results
  },
  isShowAutoComplete: ({ search }) => {
    return search.results.length > 0
  },
  /***
   * 検索候補をフォーカスしているか
   */
  isFocusedOnAutoComplete(_, getters) {
    return getters.focusedSearchResultIndex !== null
  },
  /**
   * 現在フォーカスしている候補を返す
   */
  focusedSearchResultDescription: (_, getters) => {
    const index = getters.focusedSearchResultIndex
    const results = getters.locationSearchResults
    return results[index]
  },
  /**
   * 現在フォーカスしている候補のIndexを返す
   */
  focusedSearchResultIndex: ({ search }) => {
    return search.forcedResultIndex
  },
  /**
   * 最初の候補をフォーカスしているか
   */
  isFirstSearchResultIndex: ({ search }) => {
    return !search.forcedResultIndex
  },
  /**
   * 最後の候補をフォーカスしているか
   */
  isLastSearchResultIndex: ({ search }) => {
    const { results, forcedResultIndex } = search
    const movableRange = results.length - 1
    return movableRange === forcedResultIndex
  },
  /** 地点グループ取得 */
  selectedPointGroupType: ({ pointGroupImport }) => {
    return pointGroupImport.selectedPointGroupType
  },
  pointGroupList: ({ pointGroupImport }) => {
    const { selectedPointGroupList, pointGroupList } = pointGroupImport
    return filterSelectedGroup(pointGroupList, selectedPointGroupList).filter(
      isPublicGroup,
    )
  },
  advertiserList: ({ pointGroupImport }) => {
    return pointGroupImport.advertiserList
  },
  IOList: ({ pointGroupImport }) => {
    return pointGroupImport.IOList
  },
  selectedAdvertiserId: ({ pointGroupImport }) => {
    return pointGroupImport.selectedAdvertiserId
  },
  selectedOwnerProfileId: ({ pointGroupImport }) => {
    return pointGroupImport.selectedOwnerProfileId
  },
  selectedPointGroupList: ({ pointGroupImport }) => {
    return pointGroupImport.selectedPointGroupList
  },
  selectedPointGroupCount: ({ pointGroupImport }) => {
    return pointGroupImport.selectedPointGroupList.length
  },
  selectedPointGroupLocationList: ({ pointGroupImport }) => {
    return pointGroupImport.selectedPointGroupLocationList
  },
  pointGroupImportMapCenter: ({ pointGroupImport }) => {
    return pointGroupImport.mapCenter
  },
  selectedLocationsMap: ({ pointGroupImport }) => {
    return pointGroupImport.selectedLocationsMap
  },
}

export default getters

/**
 * 選択済みのグループを候補から除外する
 * @param groupList 取得した地点グループリスト
 * @param selectedGroupList 選択済みの地点グループリスト
 * @returns {*} 地点グループリスト
 */
const filterSelectedGroup = (groupList, selectedGroupList) => {
  return groupList.filter(({ id }) => !selectedGroupList.find(g => g.id === id))
}

const isPublicGroup = group => group.accessibleType === 'public'
